import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isError: false,
    error: ""
};    


const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: { 
        createLoginError(state,action){
           state.isError = true
           state.error = action.payload    
        },
        removeLoginError(state,action){
            state.isError = false
            state.error = ""
        }
    }
});

export const selectLoginState = (state) => state.login

export const {createLoginError,removeLoginError} = loginSlice.actions

export default loginSlice.reducer;